"use client";
import React, { useState } from "react";
import dynamic from "next/dynamic";
import { useDictionary } from "../context/dictionaryProvider";

const Editor = dynamic(() => import("../components/molecules/Editor"), {
  ssr: false,
});

function ContentWithLinks({ content }) {
  const dict = useDictionary();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleReadMore = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <>
      <div
        className={`${
          isExpanded ? "max-h-full" : "max-h-80 overflow-y-hidden"
        } transition-all duration-500 ease-in-out text-base font-normal leading-[170%] tracking-[0.48px] mt-10`}
      >
        <Editor content={content?.description} className="mt-10 sm:mt-0" />
      </div>
      <button
        onClick={handleReadMore}
        className="text-base text-[#0096AC] font-[400] tracking-[1.08px] underline underline-offset-4 mt-3 mx-auto"
      >
        {isExpanded ? dict?.readLess : dict?.readMore}
      </button>
    </>
  );
}

export default ContentWithLinks;
